// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"VK-z","categoryName":"WK-z","categoryNameSearchHeader":"XK-z","categoryContent":"YK-z","bottomAligned":"ZK-z","image":"_K-z","imageNoBackground":"aL-z"};